import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareBacklogEmbedRoute: InvariantJiraRoute = {
	name: 'rapidboard-backlog-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed',
};
